import { render, staticRenderFns } from "./ProjectsCards.vue?vue&type=template&id=c5dab242&scoped=true&"
import script from "./ProjectsCards.vue?vue&type=script&lang=js&"
export * from "./ProjectsCards.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsCards.vue?vue&type=style&index=0&id=c5dab242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dab242",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VChip,VImg})
